module.exports = __webpack_public_path__ + "static/media/90800.f723c44b.png";